import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@arkius/shared-api';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs/operators';

@Component({
  selector: 'ark-lib-reset-password-modal',
  templateUrl: './reset-password-modal.component.html',
  styleUrls: ['./reset-password-modal.component.css'],
})
export class ResetPasswordModalComponent implements OnInit {
  
  formGroup!: FormGroup;

  constructor(
    private modalCtrl: ModalController,
    private authService: AuthService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.formGroup = this.fb.group({
      password: ['', [Validators.required]],
    });
  }

  formControlChange(control: string, value: any) {
    this.formGroup.get(control)?.setValue(value);
  }

  resetPassword() {
    this.authService.apiV5AuthPasswordUpdatePost(this.formGroup.value).pipe(take(1)).subscribe(() => {
      setTimeout(() => {
      this.modalCtrl.dismiss();
      }, 300);
    });
  }
}
